import { Package } from 'lucide-react';

export function SubscriptionsTab({ subscriptions, fmt, fmtDate }) {
  if (subscriptions.length === 0) return <div className="bg-white rounded-xl border border-gray-200 p-12 text-center"><Package className="w-12 h-12 text-gray-300 mx-auto mb-4" /><p className="text-gray-500">No subscriptions</p></div>;
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <table className="w-full"><thead className="bg-gray-50"><tr>
        <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Item</th>
        <th className="text-center px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Billing</th>
        <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Amount</th>
        <th className="text-center px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Next Billing</th>
        <th className="text-center px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Status</th>
      </tr></thead><tbody className="divide-y">
        {subscriptions.map(sub => (
          <tr key={sub.id} className="hover:bg-gray-50">
            <td className="px-6 py-4 font-medium">{sub.item_description}</td>
            <td className="px-6 py-4 text-center"><span className={`px-2 py-1 rounded text-xs font-medium ${sub.billing_cycle === 'monthly' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`}>{sub.billing_cycle === 'monthly' ? 'Monthly' : 'Yearly'}</span></td>
            <td className="px-6 py-4 text-right font-semibold">{fmt(sub.total)}</td>
            <td className="px-6 py-4 text-center text-gray-600">{fmtDate(sub.next_billing_date)}</td>
            <td className="px-6 py-4 text-center"><span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${sub.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>{(sub.status || 'active').toUpperCase()}</span></td>
          </tr>
        ))}
      </tbody></table>
    </div>
  );
}
